export enum enumEntrySummaryDutiesPaymentType {
  ACH = 0,
  INSTANT = 1,
}
